import { render, staticRenderFns } from "./StudentFeedback.vue?vue&type=template&id=09d3fdae"
import script from "./StudentFeedback.vue?vue&type=script&lang=js"
export * from "./StudentFeedback.vue?vue&type=script&lang=js"
import style0 from "./StudentFeedback.vue?vue&type=style&index=0&id=09d3fdae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports